import type { MenuRecipesState, RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const getRecipeIdsByCoreIds =
  (coreIds: RecipeCoreId[]) =>
  (state: MenuRecipesState): (RecipeUUID | null)[] =>
    coreIds.map((id: RecipeCoreId) => state.recipesV3.coreIdToUUID[id] || null)
